module.exports = __webpack_public_path__ + "img/verrassing-automaat.01bf92b4.jpg";